







































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class FilterDropdown<T> extends Vue {
  // [BEGIN]: Remove after refactor complete
  @Prop()
  pageFilters!: any

  @Prop()
  filedFilter?: string

  @Prop({ default: false })
  newVersion?: boolean
  // [END]: Remove after refactor complete

  @Prop()
  searchQuery?: string

  @Prop()
  fieldFilter?: string

  @Prop()
  clearable?: boolean

  @Prop()
  placeHolder?: string

  // Optional prop
  @Prop()
  selected!: any

  @Prop()
  filteredData!: T[]

  handleSelect(option) {
    this.$emit('update:pageFilters', this.pageFilters) // -> Remove after refactor complete
    this.$emit('update:selected', option)
    this.$emit('onSelected', option)
  }

  handleInput(val) {
    this.$emit('update:searchQuery', val)
  }
}
